import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Allocation, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeAllocation(request: Boundaries["removeAllocation"]["request"]): void;
}

function useRemoveAllocation(allocation: Identifiable<Allocation>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRemoveAllocationRequestPending(allocation),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRemoveAllocationRequestSuccess(allocation),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRemoveAllocationRequestFailure(allocation),
    ),
    removeAllocation: core.removeAllocation,
  };
}

export { useRemoveAllocation };
